var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2)",
    stroke: "#666",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.326 10.674c.69.689-1.133 3.628-1.822 4.317a1.765 1.765 0 01-2.495-2.495c.689-.69 3.628-2.511 4.317-1.822zm5.665 1.822a1.765 1.765 0 11-2.495 2.495c-.69-.689-2.511-3.628-1.822-4.317.689-.69 3.628 1.133 4.317 1.822zM7.504 5.009c.69.689 2.511 3.628 1.822 4.317-.689.69-3.628-1.133-4.317-1.822A1.765 1.765 0 017.504 5.01zm7.487 0c.69.689.69 1.806 0 2.495-.689.69-3.628 2.511-4.317 1.822-.69-.689 1.133-3.628 1.822-4.317.689-.69 1.806-.69 2.495 0z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 1.765a2.941 2.941 0 012.941 2.94c0 .762-.289 2.008-.763 3.117 1.109-.474 2.355-.763 3.116-.763a2.941 2.941 0 110 5.882c-.761 0-2.007-.289-3.117-.764.475 1.11.764 2.356.764 3.117a2.941 2.941 0 11-5.882 0c0-.761.289-2.007.764-3.117-1.11.475-2.356.764-3.117.764a2.941 2.941 0 010-5.882c.76 0 2.007.289 3.116.763-.474-1.11-.763-2.355-.763-3.116A2.941 2.941 0 0110 1.765z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#666",
    cx: 10,
    cy: 10,
    r: 2.353
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.058 5.975v1.558M10.058 12.642v1.557M14.025 10.058h-1.558M7.358 10.058H5.8"
  })))));
}
export default SvgSpa;